import {InjectionToken} from '@angular/core';

export const DEMO_MODE = new InjectionToken('DEMO_MODE');
